import { createTheme } from "@mui/material";
import COLORS from "./colors";
import components from "./components";
import typography from "./typography";
import { getColorVariations, HEX_OPACITY } from "./utils";
export const theme = createTheme({
  components,
  typography,
  palette: {
    mode: "dark",
    background: {
      paper: COLORS.paper,
      default: COLORS.background
    },
    text: {
      primary: COLORS.text,
      secondary: COLORS.textGray, // text-gray
      disabled: COLORS.disabled
    },
    primary: {
      ...getColorVariations(COLORS.primary),
      light: COLORS.primary + HEX_OPACITY.THREE,
      dark: COLORS.primary + HEX_OPACITY.NINE,
      contrastText: COLORS.text
    },
    secondary: {
      ...getColorVariations(COLORS.secondary),
      light: COLORS.secondary + HEX_OPACITY.THREE,
      dark: COLORS.secondary + HEX_OPACITY.NINE,
      contrastText: COLORS.text
    },
    info: {
      ...getColorVariations(COLORS.info),
      light: COLORS.info + HEX_OPACITY.THREE,
      dark: COLORS.info + HEX_OPACITY.NINE,
      contrastText: COLORS.text
    },
    success: {
      ...getColorVariations(COLORS.success),
      light: COLORS.success + HEX_OPACITY.THREE,
      dark: COLORS.success + HEX_OPACITY.NINE,
      contrastText: COLORS.text
    },
    warning: {
      ...getColorVariations(COLORS.warning),
      light: COLORS.warning + HEX_OPACITY.THREE,
      dark: COLORS.warning + HEX_OPACITY.NINE,
      contrastText: COLORS.text
    },
    error: {
      ...getColorVariations(COLORS.error),
      light: COLORS.error + HEX_OPACITY.THREE,
      dark: COLORS.error + HEX_OPACITY.NINE,
      contrastText: COLORS.text
    },
    common: {
      black: COLORS.black,
      white: COLORS.white
    },
    grey: {
      ...getColorVariations(COLORS.white)
    },
    ...{
      custom: COLORS.custom
    }
  }
});
export default theme;
